module.exports = __webpack_public_path__ + "static/media/13.d0ea9e8c.JPG";